export default __webpack_public_path__ + "static/media/el_uslugi_main_horizontal.81c2f0f3.png";